import { createAsyncAction } from 'typesafe-actions';

export const getUserNameByCpf = createAsyncAction(
  '@GET_USERNAMEBYCPF/REQUEST',
  '@GET_USERNAMEBYCPF/SUCCESS',
  '@GET_USERNAMEBYCPF/FAILURE'
)<{ cpf: string }, IUserByCpf[], string>();
